module.exports = __webpack_public_path__ + "static/media/403Error.0c636350.svg";